import { ReportingShellContext } from '../../page';
import { ReportingShellNavigatorController } from './shellNavigatorInterface';
import { ShellNavigatorControllerProps } from './shellNavigatorProps';

export function createShellNavigatorController(): ReportingShellNavigatorController {
    return {
        useProps(context, props) {
            return {
                insert: {
                    overlay: props.disclosure.insert,
                },
            };
        },
    };
}
